/**
 * Floating origin (sprint plan §5.5): display positions are float64 on the CPU; the focus point is subtracted
 * before anything is written into float32 three.js positions.
 */
import type * as THREE from 'three';
import type { Vec3 } from '../core/vec3';

export function placeRelative(obj: THREE.Object3D, display: Vec3, origin: Vec3): void {
  obj.position.set(display.x - origin.x, display.y - origin.y, display.z - origin.z);
}
